var _circle, _circle2, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "#C02D62"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9995 35C27.3884 35 34.9995 27.3888 34.9995 18C34.9995 15.0738 34.2602 12.3202 32.9581 9.91597C29.9693 7.30441 26.0581 5.72217 21.7773 5.72217C12.3885 5.72217 4.77734 13.3333 4.77734 22.7222C4.77734 25.6484 5.51669 28.402 6.81876 30.8062C9.80751 33.4178 13.7187 35 17.9995 35Z",
    fill: "#CF4476"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_25357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7969 10.125C21.085 10.1258 20.3808 10.2725 19.7278 10.556C19.0748 10.8394 18.4868 11.2537 18 11.7731C17.2867 11.0118 16.361 10.4825 15.343 10.254C14.3251 10.0254 13.2619 10.1081 12.2916 10.4914C11.3213 10.8747 10.4886 11.5408 9.90162 12.4033C9.31465 13.2658 9.00051 14.2848 9 15.3281C9 20.5087 17.3559 25.5938 17.7188 25.7934C17.8062 25.846 17.9064 25.8738 18.0084 25.8738C18.1105 25.8738 18.2106 25.846 18.2981 25.7934C18.6441 25.5938 27 20.5087 27 15.3281C26.9985 13.9486 26.4498 12.6261 25.4744 11.6506C24.4989 10.6752 23.1764 10.1265 21.7969 10.125ZM18 24.6488C16.5459 23.7206 10.125 19.3837 10.125 15.3281C10.1257 14.4619 10.4023 13.6183 10.9146 12.9198C11.4269 12.2212 12.1483 11.704 12.9743 11.4429C13.8003 11.1819 14.688 11.1907 15.5086 11.468C16.3293 11.7453 17.0404 12.2768 17.5387 12.9853C17.5907 13.059 17.6595 13.1192 17.7396 13.1607C17.8196 13.2022 17.9084 13.2239 17.9986 13.2239C18.0887 13.2239 18.1776 13.2022 18.2576 13.1607C18.3376 13.1192 18.4065 13.059 18.4584 12.9853C18.9564 12.2755 19.6676 11.743 20.4888 11.4649C21.31 11.1868 22.1985 11.1776 23.0253 11.4388C23.852 11.7 24.574 12.2178 25.0865 12.9172C25.5989 13.6166 25.8751 14.4611 25.875 15.3281C25.875 19.3809 19.4541 23.7178 18 24.6488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_25357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.001fd80f11031ae7619cd746bcebc6ba.svg";
export { ForwardRef as ReactComponent };